function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Processing = function Processing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M15.15 22.75h-11c-1.52 0-2.75-1.23-2.75-2.75V4c0-1.52 1.23-2.75 2.75-2.75h11c1.52 0 2.75 1.23 2.75 2.75v4.357c2.694.662 4.7 3.1 4.7 5.993 0 2.902-2.017 5.344-4.722 5.998a2.75 2.75 0 0 1-2.728 2.402M16.4 4v4.18a6.18 6.18 0 0 0-6.14 6.17 6.18 6.18 0 0 0 6.028 6.168 1.25 1.25 0 0 1-1.138.732h-11c-.69 0-1.25-.56-1.25-1.25V4c0-.69.56-1.25 1.25-1.25h11c.69 0 1.25.56 1.25 1.25m-2.61 2.38H5.63c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.16c.41 0 .75.34.75.75s-.34.75-.75.75M5.63 10.1h3.08c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5.63c-.41 0-.75.34-.75.75s.34.75.75.75m10.8-.42a4.669 4.669 0 1 0 0 9.34 4.669 4.669 0 1 0 0-9.34m1.41 6.97c.14.12.3.17.47.17l.01-.01c.22 0 .43-.1.58-.28.26-.32.21-.79-.11-1.05l-1.67-1.35v-2.71c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.07c0 .22.1.44.28.58z",
    clipRule: "evenodd"
  }));
};
export default Processing;
Processing.displayName = 'Processing';